










import { PaymentPlanScheduleDateTypeEnum } from '@/models';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'PaymentPlanScheduleDateTypePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: Number as PropType<PaymentPlanScheduleDateTypeEnum>
  },

  data() {
    return {
      lazyValue: this.value
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      getPaymentPlanScheduleDateVisuals:
        'paymentPlan/getPaymentPlanScheduleDateVisuals'
    }),

    dateTypes(): PaymentPlanScheduleDateTypeEnum[] {
      return this.getPaymentPlanScheduleDateVisuals;
    },

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    }
  }
});
